export const EXISTING_CUSTOMER_ERROR = 'Existing customer error';
